<script>
import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  mounted () {
    this.renderChart(this.chartdata, this.options)
  }
}
</script>

<style scoped>
#doughnut-chart {
  width: 80% !important;
  height: auto !important;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}
</style>